import { useTranslate } from '@tolgee/react';
import React, { FC, useEffect, useRef, useState } from 'react';
import CaptionModal from '../modals/captionModals';
import { useDispatch, useSelector } from 'react-redux';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';
import {
  editTextCaption,
} from '../../../../../redux/slices/textBlocks';
import '../index.css';
import DeleteConfirmation from '../../../cards/itemDeleteConfirmation';
import { lomavisShowToastr } from '../../../../../utils/ui/toastr';

interface contentCardProps {
  title: string;
  text: string;
  quillText: any;
  block: any;
  copyCaption: () => void;
  insertIntoText: () => void;
  deleteFolder: () => void;
}
const ContentCard: FC<contentCardProps> = ({
  title,
  text,
  quillText,
  block,
  copyCaption,
  insertIntoText,
  deleteFolder
}) => {
  const dispatch = useDispatch<any>();

  const { t } = useTranslate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const { cloudUuid, locationUuid } = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  // Handle drag start event
  const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    // Set the data to be transferred - the text block UUID
    e.dataTransfer.setData('text/plain', block.uuid);
    // Set the drag effect to move
    e.dataTransfer.effectAllowed = 'move';
  };

  const formattedText = text?.replace(/\n/g, '<br/>');

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div className="w-100 d-flex flex-column gap-2 mb-5 px-2">
      <div 
        className="position-relative w-100 shadow-sm rounded p-2 d-flex gap-3 overlay-wrapper"
        draggable={true}
        onDragStart={handleDragStart}
      >
        <div className="h-100 px-4">
          <i className="fa-duotone fa-solid fa-quote-left fs-1 text-primary"></i>
        </div>
        <div className="d-flex flex-column gap-3 w-100">
          <h4 className="text-gray-700 fw-bold cursor-pointer mb-0">{title}</h4>

          <div
            className={`mb-4 text-gray-600 fw-semibold fs-6  ${
              isExpanded ? '' : 'text-clamp-3'
            }`}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        </div>

        {/* Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100 bg-primary bg-opacity-25 d-flex flex-column justify-content-between align-items-start opacity-0 overlay-transition p-2 cursor-pointer rounded"
          onClick={() => {
            insertIntoText();
          }}
        >
          <div className="w-100 d-flex justify-content-end">
            <div
              className="p-2 px-3 m-0 fs-6 rounded-pill badge bg-secondary text-black"
              onClick={() => {
                insertIntoText();
              }}
            >
              {t('lomavisCreator.textBlock.useInCreator')}
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-between">
            <div
              className="badge bg-white d-flex justify-content-center align-items-center rounded z-1"
              style={{
                width: '30px',
                aspectRatio: 1
              }}
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded(!isExpanded);
              }}
            >
              <i
                className={`fa-solid ${
                  isExpanded ? 'fa-caret-up' : 'fa-caret-down'
                } fs-4`}
              ></i>
            </div>

            <div className="d-flex gap-3">
              <div
                className="badge bg-white d-flex justify-content-center align-items-center rounded z-1"
                style={{
                  width: '30px',
                  aspectRatio: 1
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowEditModal(true);
                }}
              >
                <i className="fa-solid fa-pencil fs-4"></i>
              </div>

              <div
                className="badge bg-white d-flex justify-content-center align-items-center rounded z-1"
                style={{
                  width: '30px',
                  aspectRatio: 1
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDeleteModal(true);
                }}
              >
                <i className="fa-duotone fa-solid fa-trash fs-4 text-danger"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="useAsOverlay d-flex justify-content-end align-items-start w-100 h-100 ">
        <Button
          variant="secondary"
          size="sm"
          className="p-1 px-2 m-0 fs-6 rounded-pill"
          onClick={() => {
            insertIntoText();
          }}
        >
          {t('lomavisCreator.textBlock.useInCreator')}
        </Button>
      </div> */}
      {/* <div
        className="d-flex align-items-center gap-3 position-relative w-100 justify-content-end"
        ref={dropdownRef}
      >
        <Dropdown show={showDropdown} onToggle={() => {}} align="end">
          <Dropdown.Toggle
            as="span"
            onClick={() => setShowDropdown((prev) => !prev)}
            className="cursor-pointer no-caret"
            style={{ border: 'none', background: 'none' }}
          >
            <i className="fa-duotone fa-solid fa-ellipsis fs-2"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu onClick={() => setShowDropdown(false)}>
            <Dropdown.Item onClick={() => setShowEditModal(true)}>
              {t('lomavisCreator.textBlock.editCaption')}
            </Dropdown.Item>
            <Dropdown.Item onClick={deleteFolder} className="text-danger">
              {t('lomavisCreator.textBlock.deleteCaption')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div> */}

      <DeleteConfirmation
        handleCancel={() => setShowDeleteModal(false)}
        handleDelete={() => {
          deleteFolder();
          setShowDeleteModal(false);
        }}
        keyText={'item_delete'}
        show={showDeleteModal}
      />

      {showEditModal && (
        <CaptionModal
          show={showEditModal}
          onClose={() => setShowEditModal(false)}
          title={title}
          quillText={quillText}
          onCreate={({ title, text_as_html, text_quill }) => {
            dispatch(
              editTextCaption(
                locationUuid,
                cloudUuid,
                {
                  title: title,
                  uuid: block?.uuid,
                  text_quill: text_quill,
                  text_as_html,
                  location: block?.location
                },
                () => {
                  lomavisShowToastr(
                    t('lomavisPostApproval.textBlock.success_captionEdited'),
                    'success'
                  );
                },

                () => {
                  lomavisShowToastr(
                    t('lomavisPostApproval.textBlock.err_captionEdited'),
                    'error'
                  );
                }
              )
            );
          }}
          action="edit"
        />
      )}
    </div>
  );
};

export default ContentCard;
